import type { ErrorResponse } from "@apollo/client/link/error";
import type { Event } from "@sentry/types";

import type { ExecutionResultWithAuthData } from "@shared/types/executionResultWithAuthData";

let enableErrors = true;
const turnOffErrorReportingIfLoggedOut = (
  networkError: ErrorResponse["networkError"],
  response?: ExecutionResultWithAuthData
) => {
  const isUserLoggedOut = response?.authentication && !response?.authentication?.role;

  if (networkError || isUserLoggedOut) {
    enableErrors = false;
  }
};

const turnOffErrorReporting = () => {
  enableErrors = false;
};

const errorsTurnedOffFilter = (event: Event): Event | null => {
  if (enableErrors) return event;

  return null;
};

export { errorsTurnedOffFilter, turnOffErrorReporting, turnOffErrorReportingIfLoggedOut };
